import * as React from 'react';
import * as _ from 'lodash';
import SearchBar from '../../components/SearchBar';
import { cleanProps } from '../../utilities/props';
import { GlobalHeaderButtons } from '../../components/PageLayout/GlobalHeaderButtons';
export default function (props, context) {
    function mergeProps(inline, external) {
        var res = _.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function onChange2(e) {
        props.setSearchTerm(e.target.value);
    }
    return React.createElement('div', mergeProps({ 'className': 'app-header app-header-adj' }, _.assign({}, cleanProps(props))), React.createElement(GlobalHeaderButtons, {}), React.createElement('div', { 'className': 'lightbox-header-container' }, React.createElement('div', { 'className': 'lightbox-title-block' }, React.createElement('h1', { 'id': 'PageTitle' }, 'Project Scope'), React.createElement('p', {}, 'Select the feature groups are available for quoting.'))), React.createElement(SearchBar, {
        'value': props.term,
        'onChange': onChange2.bind(this)
    }));
}